module.exports = __webpack_public_path__ + "img/sudoku-bg.9b69633a.jpg";